export default {"src":"https://fishbrain.com/_next/static/media/bragIconGear.44d6a93c.svg","height":51,"width":68,"blurWidth":0,"blurHeight":0};